// Copyright (c) 2024 WiseTime. All rights reserved.

import { t } from "@lingui/macro"
import { activateI18n } from "../../locales/i18nUtil"

activateI18n()

export const PULL_TO_REFRESH_ID = "pull-to-refresh"
export const pullToRefreshOptions = {
  mainElement: `#${PULL_TO_REFRESH_ID}`,
  instructionsPullToRefresh: t({ id: "label_pull_down_to_refresh", message: "Pull down to refresh" }),
  instructionsReleaseToRefresh: t({ id: "label_release_to_refresh", message: "Release to refresh" }),
  instructionsRefreshing: t({ id: "label_refreshing", message: "Refreshing" }),
}
